<script setup lang="ts">
import { PropType } from "vue";
import { IOfferCard } from "@/package/global-types";
import { IconHeartRegular } from "@packages/icon-library";
import { useI18n } from "vue-i18n";

defineProps({
  offer: {
    type: Object as PropType<IOfferCard>,
    required: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="offer-card">
    <button type="button">
      <IconHeartRegular />
    </button>
    <RouterLink :to="{ query: { offer: offer.id } }">
      <div
        class="offer-card__preview"
        :style="{
          backgroundImage: `url(${offer.image_src})`,
        }"
      />

      <div class="offer-card__info">
        <h5>
          {{ t("offer.reward") }} <span>{{ offer.cashback }}</span>
        </h5>
      </div>
    </RouterLink>
  </div>
</template>

<style scoped lang="scss">
.offer-card {
  position: relative;
  height: auto;
  width: 100%;
  border-radius: 16px;
  border: 2px solid var(--color-semantic-border-normal-soft);
  background-color: var(--color-semantic-background-normal-primary);
  overflow: hidden;
  flex-shrink: 0;

  @media (hover: hover) {
    &:hover {
      border-color: var(--color-semantic-border-normal-hard);
    }
  }

  > button {
    top: 16px;
    position: absolute;
    right: 16px;
    z-index: 2;
    opacity: 0;

    > .icon {
      background-color: var(--color-semanti-content-normal-secondary);
      width: 40px;
      height: 40px;
    }
  }

  > a {
    width: 100%;
    display: block;
  }

  &__preview {
    aspect-ratio: 16/9;
    @include centerBackgroundImageContain();
  }

  &__info {
    margin: calc($base-space * 2) 0 0;
    padding: 0 0 ($base-space * 4);

    > h5 {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      gap: $base-space;
      @include body-l();
      color: var(--color-semantic-content-normal-tertiary);

      @media (max-width: 1239px) {
        @include body-m();
      }

      > span {
        @include h4();
        color: var(--color-semantic-content-normal-primary);

        @media (max-width: 1239px) {
          @include h5();
        }
      }
    }
  }
}
</style>
